import { render, staticRenderFns } from "./price-dialog.vue?vue&type=template&id=521e1cb3&scoped=true&"
import script from "./price-dialog.vue?vue&type=script&lang=js&"
export * from "./price-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e1cb3",
  null
  
)

export default component.exports